import { Component, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, updateData} from './constants.js';
const moment = require('moment');

function ComplaintList(props) {
    const complaint_list = props.data.map((item)=>
      <tr key={item.id} id={item.id}>
          <td>{moment(item.created_date).format("l")}</td>
          <td>{item.created_user}</td>
          <td>{item.nature}</td>
          <td className="text-nowrap">{item.status?'Closed':'Pending'}</td>
          <td><Link id={item.id} className="font-weight-bold" to={'/complaint/'+item.id}>View details</Link></td>
      </tr>
    );
    return(
        <>
        <div className="row">
            <div className="col-xs-12 col-md-12">

                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h4 className="m-0 font-weight-bold text-white">Complaints</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive complaint-table">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Complaint Date</th>
                                        <th>Filed By</th>
                                        <th>Complaint's Nature</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {complaint_list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

class Complaints extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true
    };
  }

  async getComplaints() {
    try {
      const response = await fetch('/api/complaints');
      const json = await response.json();
      console.log(json);
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getComplaints();
  }

  render() {
    return (
      <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <ComplaintList data={this.state.data} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
      </>
    );
  }
}

class ComplaintResponseForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        complaint_id   :this.props.complaintId,
        response_text  :"",
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const value =  target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    }

    handleSubmit(event) {
      event.preventDefault();
      var data = this.state;
      console.log(data);
      postData('/api/complaint_response', data)
        .then((response) => {
          console.log(response);
          this.setState({'response_text': ''})
          this.props.getComplaintDetails();
      });
    }

    render() {
      return(
        <form className="user mt-2" onSubmit={this.handleSubmit} autoComplete="off">
          <fieldset id="complaint-response-form">
            <small className="fw-bold">Comment </small>
            <div className="row">
                <div className="col-lg-12 col-xs-12">
                    <div className="input-group">
                      <input type="text" name="response_text" value={this.state.response_text} onChange={this.handleInputChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" required />
                      <div className="input-group-append">
                        <button className="btn btn-outline-primary input-group-button"><i className="fas fa-comment-alt action-buttons"></i></button>
                      </div>
                    </div>
                </div>
            </div>
          </fieldset>
        </form>
      );
    }
}

class ComplaintDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id     : this.props.data.id,
      status : this.props.data.status
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    updateData('/api/complaint-status/'+data.id, data)
      .then((response) => {
        console.log(response);
        this.props.navigate("/complaints");
    });
  }

  render(){
    var data = this.props.data;
    const complaint_responses = this.props.responses.map((item,index)=>{
      return(
        <div key={item.id} className="row no-gutters my-1">
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12 text-dark"}>
            {item.response_text}
          </div>
          <div className={item.commented_resident?"col-12 d-flex justify-content-end":"col-12"}>
            <small className="mx-2">{item.commented_user},</small>
            <small className="m-0">{moment(item.created_date).format("lll")}</small>
          </div>
        </div>
      );
    });
    return (
      <>
        <div className="row">
          <div className="col-xs-12 col-md-6 col-lg-8">
            <div className="card shadow-sm mb-2">
                <div className="card-header py-3">
                    <h4 className="m-0 font-weight-bold text-light">Complaint Details</h4>
                </div>
                <div className="card-body acc-approval-form">
                  <div className="row mb-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Complaint Registerd on </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {moment(data.created_date).format("LLL")} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Complaint Filed by </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.created_user} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Complaint's Nature </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.nature} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Complaint's Status </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.status?'Closed':'Pending'} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4 font-weight-bold">Complaint Description </div>
                    <div className="col-xs-6 col-md-8 font-weight-bold"> {data.description} </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-xs-6 col-md-4">
                      <a href={data.file_ref} target="_blank" className="fw-bold hyperlink"> View attachments </a>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-xs-6 col-md-4">
                      <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                          <div className="form-group">
                              <label>Update Complaint Status</label>
                              <select name="status" className="form-select" value={this.state.status} onChange={this.handleInputChange}>
                                  <option value={0}>Pending</option>
                                  <option value={1}>Closed</option>
                              </select>
                          </div>
                          <div className="form-group mb-0">
                            <input type="submit" className="btn btn-bg-success mr-2" value="Submit" />
                            <Link to="/complaints" className="btn btn-danger">Cancel</Link>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 col-lg-4">
            <div className="card shadow mb-2">
              <div className="card-header">
                  <h4 className="m-0 font-weight-bold text-light">Responses</h4>
              </div>
              <div className="card-body">
                <div className="complaint-response-view">
                  {complaint_responses}
                </div>
                <ComplaintResponseForm complaintId={data.id} getComplaintDetails={this.props.getComplaintDetails} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function ViewComplaint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [complaintData, setComplaintData] = useState({});
  const [complaintResponses, setComplaintResponses] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getComplaintDetails = async() => {
    try {
      const response = await fetch('/api/complaint/'+id);
      const json = await response.json();
      setComplaintData(json.complaint);
      setComplaintResponses(json.complaint_responses);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getComplaintDetails();
  }, []);

  return(
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                    {!isLoading?
                      <ComplaintDetails data={complaintData} responses={complaintResponses} getComplaintDetails={getComplaintDetails} navigate={navigate} />
                    :
                      <> </>
                    }
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
}

export { Complaints, ViewComplaint };
